import React from "react"
import { Control } from "react-hook-form"
import { BadgeElementFormValues } from "components/BadgeBuilder/Panels/EditorPanel/BadgeSidePanelForm"
import BadgeTextContentFields from "./BadgeTextContentFields"
import TextStyleFields from "./TextStyleFields"

type Props = {
  control: Control<BadgeElementFormValues>
  variant: "static" | "field"
  group?: boolean
}

const BadgeTextFields = ({ control, variant, group = false }: Props) => (
  <>
    {!group && <BadgeTextContentFields control={control} variant={variant} />}
    <TextStyleFields control={control} />
  </>
)

export default BadgeTextFields
